type IndeterminateProgressBarColors = 'default' | 'primary' | 'secondary' | 'variant';
export interface IndeterminateProgressBarProps {
    color?: IndeterminateProgressBarColors;
    size?: number;
}

export function IndeterminateProgressBar(props: IndeterminateProgressBarProps) {
    const spinnerColor: Record<IndeterminateProgressBarColors, { parentBg: string; childBg: string }> = {
        default: { parentBg: 'bg-primary-800', childBg: 'bg-primary-100' },
        primary: { parentBg: 'bg-primary-500', childBg: 'bg-primary-100' },
        secondary: { parentBg: 'bg-secondary-500', childBg: 'bg-secondary-100' },
        variant: { parentBg: 'bg-variant-800', childBg: 'bg-variant-100' },
    };

    return (
        <div className="w-full">
            <div className={`h-1.5 rounded w-full overflow-hidden ${spinnerColor[props.color || 'default'].childBg}`}>
                <div
                    className={`progress w-full h-full ${spinnerColor[props.color || 'default'].parentBg} left-right`}
                ></div>
            </div>
        </div>
    );
}

IndeterminateProgressBar.defaultProps = {
    color: 'default',
};

export default IndeterminateProgressBar;
